import React,{useRef,useEffect,useState} from 'react';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useServiceContext } from '../../components/Context/ServiceContext';
import Chip from '@mui/material/Chip';
import { Grid,Tabs, Tab, Box, Typography, Stack, Button, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Checkbox, ListItemText,TextField } from '@mui/material';
import { useProgressBar } from '../ProgressBar';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../SnackBar';
const CoupansOffersView=()=>{
    const navigate = useNavigate();
    const {branches,FetchBranches} = useBranchContext();
    const {AddCoupans,GetPartnerServices} = useServiceContext();
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedServices, setSelectedservices] = useState([]);
    const [selectedServicesone, setSelectedservicesone] = useState([]);
    const [services, setServices] = React.useState([]);
    const didFetch=useRef(false);
    const coupannameRef=useRef();
    const validtyuptoRef=useRef();
    const countofServiceRef=useRef();
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const fetchData = async () => {
           try {
                await FetchBranches();
                setServices(await GetPartnerServices());
               } catch (error) {
                
               console.error("Error fetching data:", error);
           }
    };
    useEffect(() => {
          
           if (!didFetch.current) {
               fetchData();
               didFetch.current = true;
           }
    },[fetchData]);

    const handleChange = (event) => { 
        if(event.target.name==='branch'){
            const { target: { value }, } = event; 
            setSelectedBranches( typeof value === 'string' ? value.split(',') : value, ); 
        }
        if(event.target.name==='service'){
            const { target: { value }, } = event; 
            setSelectedservices( typeof value === 'string' ? value.split(',') : value, ); 
        }
        if(event.target.name==='service1'){
            const { target: { value }, } = event; 
            setSelectedservicesone( typeof value === 'string' ? value.split(',') : value, ); 
        }
    };
    const[serviceNumberOfTimes,setNumberOfTimes]=useState({});
    const handleNumberOfTimes = (id, count) => {
        const serviceId = parseInt(id, 10);
        const availCount = parseInt(count, 10);
      
        // Update the state with the new object
        setNumberOfTimes((prevState) => ({
            ...prevState,
            [serviceId]: availCount,
        }));
      };
    const handleAddCoupans = async () =>{
        handleClick();
        if(coupannameRef.current.value.trim() ===""||validtyuptoRef.current.value.trim()===""||selectedBranches===""||selectedServices===""||selectedServicesone===""){
        showSnackbar('Fields cannot be empty.');
        return;
      }else{
        const transformedServicesApplicable = Object.entries(serviceNumberOfTimes).map(([serviceId, availCount]) => (
            { 
                serviceId: parseInt(serviceId, 10),
                availCount: parseInt(availCount, 10), 
            }));

            showProgress(true);  
                 const d=await AddCoupans({ 
                     id:0,
                     name:coupannameRef.current.value,
                     validity:validtyuptoRef.current.value,
                     servicesOffered:selectedServices,
                     servicesApplicable:transformedServicesApplicable,
                     branchesAvailable:selectedBranches,
                     isActive:false,
                     isDeleted:false,
                 });
                 showSnackbar('Coupan added successfully', 'success');
                showProgress(false);
               setTimeout(()=>{navigate(`/Coupansedit/${d.id}/false`)},2000);
         
        }
    }
    const formRef=useRef([]);
    const handleClick=()=>{
        const formElements=formRef.current.elements;
            for(let elements of formElements){
                    if(elements.tagName==='INPUT' && (elements.type!='submit' || elements.type!="button")){
                       
                        if(elements.value==""){
                            elements.style.borderColor='red';
                        }else{
                            elements.style.borderColor='';
                    }
                }
            }
    }
    const emptyFieldCheck=(e)=>{
        if(e.target.value==""){
            e.target.style.borderColor='';
        }else{
            e.target.style.borderColor='';
        }

    }
    return(
        <main id="main" className="main">
            <div className="pagetitle">
                <h1> Coupans And Offers</h1>
                <nav>
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><a href="/CoupanList">Home</a></li>
                       
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Coupan Details</h5>
                                <div>
                                    <form ref={formRef}>
                                        {/* Name Input */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Coupan Name:</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" style={{ width: '300px' }}  name="coupanname" ref={coupannameRef} onBlur={(e)=>{ emptyFieldCheck(e); }}/>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Validty Up To:</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" style={{ width: '300px' }} name="validtyupto" ref={validtyuptoRef} onBlur={(e)=>{ emptyFieldCheck(e); }}/>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Select Branches for Adding Coupons:</label>
                                            <div className="col-sm-8">
                                            <FormControl fullWidth sx={{ width: '300px' }}> 
                                                <Select 
                                                    id="branch" 
                                                    name="branch" 
                                                    className="form-control" 
                                                    multiple 
                                                    value={selectedBranches} 
                                                    onChange={handleChange} 
                                                    renderValue={(selected) => (
                                                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}> 
                                                                {selected.map((value) => { 
                                                                        const selectedItem = branches.find(item => item.id === value); 
                                                                        return ( 
                                                                        <Chip 
                                                                            key={value} 
                                                                            label={selectedItem?.name} 
                                                                        /> 

                                                                        ); 
                                                                      })} 
                                                                      </Box> 
                                                                      )} 
                                                                        sx={{ 
                                                                                width: "300px", 
                                                                                "& .MuiOutlinedInput-root": {}, 
                                                                                "& .MuiSelect-select": { 
                                                                                    padding: "8px 12px", 
                                                                                }, 
                                                                            }} 
                                                                        > 
                                                                            {(branches || []).map((branch) => ( 
                                                                                <MenuItem key={branch.id} value={branch.id}> 
                                                                                    <Checkbox checked={selectedBranches.includes(branch.id)} /> 
                                                                                    <ListItemText primary={branch.name} /> 
                                                                                </MenuItem> ))} 
                                                </Select> 
                                            </FormControl>
                                         
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Select Services for Adding Coupons:</label>
                                            <div className="col-sm-8">
                                            <FormControl fullWidth sx={{ width: '300px' }}> 
                                                <Select 
                                                    id="service" 
                                                    name="service" 
                                                    className="form-control" 
                                                    multiple 
                                                    value={selectedServices} 
                                                    onChange={handleChange} 
                                                    renderValue={(selected) => (
                                                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}> 
                                                                {selected.map((value) => { 
                                                                        const selectedItem = services.find(item => item.id === value); 
                                                                        return ( 
                                                                        <Chip 
                                                                            key={value} 
                                                                            label={selectedItem?.name} 
                                                                        /> 

                                                                        ); 
                                                                      })} 
                                                                      </Box> 
                                                                      )} 
                                                                        sx={{ 
                                                                                width: "300px", 
                                                                                "& .MuiOutlinedInput-root": {}, 
                                                                                "& .MuiSelect-select": { 
                                                                                    padding: "8px 12px", 
                                                                                }, 
                                                                            }} 
                                                                        > 
                                                                            {(services || []).map((service) => ( 
                                                                                <MenuItem key={service.id} value={service.id}> 
                                                                                    <Checkbox checked={selectedServices.includes(service.id)} /> 
                                                                                    <ListItemText primary={service.name} /> 
                                                                                </MenuItem> ))} 
                                                </Select> 
                                            </FormControl>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Select Services for Coupon Application:</label>
                                            <div className="col-sm-8">
                                            <FormControl fullWidth sx={{ width: '300px' }}> 
                                                <Select 
                                                    id="service" 
                                                    name="service1" 
                                                    className="form-control" 
                                                    multiple 
                                                    value={selectedServicesone} 
                                                    onChange={handleChange} 
                                                    renderValue={(selected) => (
                                                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}> 
                                                                {selected.map((value) => { 
                                                                        const selectedItem = services.find(item => item.id === value); 
                                                                        return ( 
                                                                        <Chip 
                                                                            key={value} 
                                                                            label={selectedItem?.name} 
                                                                        /> 

                                                                        ); 
                                                                      })} 
                                                                      </Box> 
                                                                      )} 
                                                                        sx={{ 
                                                                                width: "300px", 
                                                                                "& .MuiOutlinedInput-root": {}, 
                                                                                "& .MuiSelect-select": { 
                                                                                    padding: "8px 12px", 
                                                                                }, 
                                                                            }} 
                                                                        > 
                                                                            {(services || []).map((service) => ( 
                                                                                <MenuItem key={service.id} value={service.id}> 
                                                                                    <Checkbox checked={selectedServicesone.includes(service.id)} /> 
                                                                                    <ListItemText primary={service.name} /> 
                                                                                </MenuItem> ))} </Select> 
                                            </FormControl>

                                            {selectedServicesone.map((value) => { 
                                                const selectedItem = services.find(item => item.id === value); 
                                                return ( <Box key={value} sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}> 
                                                <Box sx={{ marginRight: '10px', width: '30%' }}> 
                                                    <InputLabel>{selectedItem?.name}</InputLabel> 
                                                </Box>
                                                 <Box sx={{ width: '70%' }}> 
                                                    <input type="text" 
                                                    className="form-control" 
                                                    style={{ padding: '10px', height: '40px', width: '100%' }} 
                                                    placeholder="Enter Number of Times" 
                                                    value={serviceNumberOfTimes[value] || ''} 
                                                    onChange={(e) => handleNumberOfTimes(value, e.target.value)}/> 
                                                    </Box> 
                                                </Box> 
                                            ); })}

                                             </div>
                                        </div>
                                        <div className="row mb-3">
                                            {/* <label className="col-sm-2 col-form-label">How many times can coupan be used for this sevice?:</label>
                                            <div className="col-sm-8">
                                               <input type="text" className="form-control" style={{ width: '300px' }} ref={countofServiceRef}/>
                                            </div>*/}
                                        </div>

                                       {/* Save Button */}
                                     
                                        <div className="col-12 d-flex justify-content-end align-items-end" style={{ minHeight: "100px" }}>
                                            <button
                                                type="button"
                                                className="btn btn-primary px-3 py-2"
                                                onClick={handleAddCoupans}
                                            >
                                                Save
                                            </button>
                                        </div>
                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
export default CoupansOffersView;